module.exports = __webpack_public_path__ + "img/ce7acca.jpg";